import { glyphs, uiGlyphs } from './glyphs';

export function Glyph({ family = 'ui', name, size = 20, strokeWidth = 1.3, style, ...props }) {
  const entry = family === 'ui' ? uiGlyphs[name] : glyphs[family]?.[name];
  const path = Array.isArray(entry) ? entry[0] : entry;
  return <svg viewBox="0 0 20 20" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block', flex: 'none', ...style }} aria-hidden="true" {...props}><path d={path} /></svg>;
}
